const AUTH_INVALID_EVENT = 'zwen-auth-invalid'
const PLAYBACK_DEVICE_KEY = 'zwen_playback_device_id'

export function hasAuthToken () {
  return !!localStorage.getItem('zwen_token')
}

export function playbackDeviceId () {
  let value = localStorage.getItem(PLAYBACK_DEVICE_KEY)
  if (!value) {
    value = 'web-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12)
    localStorage.setItem(PLAYBACK_DEVICE_KEY, value)
  }
  return value
}

export function safeRedirect (value, fallback) {
  const path = typeof value === 'string' ? value.trim() : ''
  if (!path || path.charAt(0) !== '/' || path.indexOf('//') === 0 || path.indexOf('/login') === 0) {
    return fallback || '/'
  }
  return path
}

export function loginRedirect (route) {
  return safeRedirect(route && route.fullPath, '/')
}

export function goToLogin (router, route, expired) {
  if (expired) {
    localStorage.removeItem('zwen_token')
    if (typeof window !== 'undefined') window.dispatchEvent(new Event(AUTH_INVALID_EVENT))
  }
  if (!router || (router.currentRoute && router.currentRoute.name === 'login')) return
  router.replace({
    name: 'login',
    query: {
      redirect: loginRedirect(route || router.currentRoute),
      reason: expired ? 'expired' : 'required'
    }
  }, () => {}, () => {})
}

export function isUnauthorized (body, status) {
  if (Number(status) === 401 || Number(body && body.code) === 401) return true
  const message = String((body && body.message) || '').toLowerCase()
  return message.indexOf('暂未登录') >= 0 || message.indexOf('token已经过期') >= 0 ||
    message.indexOf('token 已经过期') >= 0 || message.indexOf('token expired') >= 0
}

export { AUTH_INVALID_EVENT }



// WEBPACK FOOTER //
// ./src/utils/auth.js